<ng-container *ngIf="liveLicense; else demoLicense">
  <ng-container *yatVar="endOfPeriod && terminationDate && terminationDate > endOfPeriod as noticePeriodExpired">
    <p>
      <transloco
        id="b529d073-5fcc-475f-9e00-51938259c532"
        [key]="
          noticePeriodExpired
            ? 'marketplace.asset.subscriptionCancel.licenseWillBeCanceledAfterPayment'
            : 'marketplace.asset.subscriptionCancel.licenseWillBeCanceledWithoutPayment'
        "
        [params]="{
        productName,
        endOfPeriod: endOfPeriod ? (endOfPeriod | translocoDate: { dateStyle: 'medium' }) : '',
        terminationDate: terminationDate ? (terminationDate | translocoDate: { dateStyle: 'medium' }) : ''
      }">
      </transloco>
    </p>
  </ng-container>
</ng-container>
<ng-template #demoLicense>
  <p>{{ 'marketplace.asset.subscriptionCancel.demoWillBeDeleted' | transloco }}</p>
</ng-template>
<yat-buttons
  [primaryButtonName]="(liveLicense ? 'marketplace.asset.subscriptionCancel.confirmCancelation' : 'marketplace.asset.subscriptionCancel.resetDemo') | transloco"
  [negativePrimaryButton]="true"
  [secondaryButtonName]="((buttonBackName === 'back' ? 'back' : 'close') | commonWording | async) ?? ''"
  (primaryButtonClickMethod)="cancelSubscription()"
  (secondaryButtonClickMethod)="back()"
  [className]="buttonsClassName"
  [matomoEventCategory]="MATOMO_EVENT_CATEGORY_PURCHASE"
  matomoEventClickPrimaryButtonAction="liveLicense ? 'Select_CancelSubscription' : 'Select_DemoReset'"
  matomoEventClickSecondaryButtonAction="Cancel_CancelSubscription">
</yat-buttons>
